import { getToken, removeToken, setToken } from '@/utils/auth';
import { getUserInfo } from '@/api/login';
import router from '@/router';
const loginModes = ['code', 'password', 'register', 'reset'];

function getLoginMode(mode) {
    return loginModes.includes(mode) ? mode : 'code';
}

export default {
    namespaced: true,
    state: {
        token: getToken() || '',
        userInfo: null,
        loginDialogVisible: false,
        loginDialogMode: 'code',
        loginReason: ''
    },
    mutations: {
        OPEN_LOGIN_DIALOG(state, payload = {}) {
            state.loginDialogMode = getLoginMode(payload.mode);
            state.loginReason = payload.reason || '';
            state.loginDialogVisible = true;
        },
        CLOSE_LOGIN_DIALOG(state) {
            state.loginDialogVisible = false;
            state.loginDialogMode = 'code';
            state.loginReason = '';
        },
        SET_TOKEN(state, token) {
            state.token = token || '';
        },
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo || null;
        },
        CLEAR_AUTH(state) {
            state.token = '';
            state.userInfo = null;
        }
    },
    actions: {
        async fetchUserInfo({ state, commit }) {
            if (state.userInfo) {
                return state.userInfo
            }
            try {
                let res = await getUserInfo()
                commit('SET_USER_INFO', res.user)
                return res.user
            } catch(e) {
                return null
            }
            
        },
        openLoginDialog({ commit }, payload) {
            commit('OPEN_LOGIN_DIALOG', payload);
        },
        requireAuthentication({ state, dispatch }, payload) {
            if (state.token) {
                return true;
            }
            dispatch('openLoginDialog', payload);
            return false;
        },
        closeLoginDialog({ commit }) {
            commit('CLOSE_LOGIN_DIALOG');
        },
        handleSessionExpired({ commit }) {
            removeToken();
            // 若当前已在首页则无需跳转，避免 NavigationDuplicated 报错
            if (router.currentRoute.path !== '/') {
                router.replace("/").catch(() => {})
            }
            commit('CLEAR_AUTH');
            commit('OPEN_LOGIN_DIALOG', {
                reason: 'Your session has expired. Please sign in again.'
            });
        },
        saveAuthentication({ commit }, { token }) {
            setToken(token);
            commit('SET_TOKEN', token);
            // commit('SET_USER_INFO', userInfo);
            commit('CLOSE_LOGIN_DIALOG');
        },
        saveUserInfo({commit}, userInfo) {
            commit('SET_USER_INFO', userInfo)
        },
        clearAuthentication({ commit }) {
            removeToken();
            if (router.currentRoute.path !== '/') {
                router.replace("/").catch(() => {})
            }
            commit('CLEAR_AUTH');
            commit('CLOSE_LOGIN_DIALOG');
        }
    }
};
